import { client } from 'config/environment'
import { createContext, ReactNode, useContext, useMemo } from 'react'

export type Store = {
  tsum: boolean
}

const Context = createContext<Store | undefined>(undefined)
const Provider = Context.Provider

type Props = {
  children: ReactNode
  tsum: boolean
}

export function UiProvider(props: Props) {
  const { children, tsum } = props

  const store = useMemo(() => {
    if (client) document.documentElement.classList.toggle('tsum', tsum)
    return { tsum }
  }, [tsum])

  return <Provider value={store}>
    {children}
  </Provider>
}

export function useUi(): Store {
  const context = useContext(Context)
  if (!context) throw new Error('no context')
  return context
}
